import { Reveal } from "./Reveal";

const PROCESS_STEPS = [
  { step: "01", title: "Define", desc: "One call to map the role, the stack and the seniority bar your roadmap needs." },
  { step: "02", title: "Vet", desc: "Technical depth and meeting-ready English, validated by senior engineers, not recruiters." },
  { step: "03", title: "Shortlist", desc: "Around 3 curated, pre-vetted senior profiles in under five business days." },
  { step: "04", title: "Start", desc: "You interview the finalists directly. Free replacement guarantee behind every placement." },
];

export default function ProcessCore() {
  return (
    <section id="process" className="bg-white py-14 sm:py-20" data-testid="v2-process-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="text-center">
            <p className="font-cond text-xs font-bold uppercase tracking-[0.28em] text-brand-orange">
              The process
            </p>
            <h2 className="mx-auto mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-brand-teal sm:text-4xl">
              From requirement to embedded senior in under five days
            </h2>
          </div>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PROCESS_STEPS.map((item, i) => (
            <Reveal key={item.step} delay={0.08 * i}>
              <div className="h-full rounded-2xl bg-brand-mist p-7" data-testid={`process-step-${i + 1}`}>
                <div className="flex items-baseline gap-3">
                  <p className="font-display text-3xl font-extrabold text-brand-orange">{item.step}</p>
                  <p className="font-display text-lg font-bold text-brand-teal">{item.title}</p>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-brand-slate">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
